import React from "react";

import Styled from "./SAPHeroBannerStyles";
import { ColorSAP, FONT_FAMILY, Typography } from "../../ontego-ui";
import Button from "../Button/Button";
import ProjectPlanningImgDE from '../../assets/img/scenario/project-planning-de.png';
import ProjectPlanningImg from '../../assets/img/scenario/project-planning-en.png';
import { useTranslation } from "react-i18next";
import { lineHeight } from "@mui/system";

const SAPHeroBanner = ({
  subtitle,
  title,
  description,
  buttonText,
  onButtonClick,
  assetImage,
  assetImageAlt = "",
}) => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language;

  return (
    <Styled.Container>

      <Styled.GradientOverlayYellow />
      <Styled.GradientOverlayGray />

      <Styled.Inner>
        <Styled.Content>

          {subtitle && (
            <Typography
              fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD_ITALIC}
              size={32}
              color={ColorSAP.secondary[30]}
              style={{ marginBottom: "32px", lineHeight: "42px" }}
            >
              {subtitle}
            </Typography>
          )}

          {title && (
            <Typography
              fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
              size={32}
              color={ColorSAP.neutral[0]}
              style={{ marginBottom: "12px", lineHeight: "42px" }}
            >
              {title}
            </Typography>
          )}

          {description && (
            <Typography
              fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
              size={18}
              color={ColorSAP.neutral[0]}
              style={{ width: "608px", marginBottom: "32px", lineHeight: "25px" }}
            >
              {description}
            </Typography>
          )}

          {buttonText && (
            <Button
              type="primary"
              theme="light"
              size="medium"
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          )}
        </Styled.Content>

        <div
          style={{
            position: 'absolute',
            top: 108,
            width: 486,
            height: 632,
            right: 0,
            backgroundImage: `url(${currentLanguage === 'en' ? ProjectPlanningImg : ProjectPlanningImgDE})`,
            backgroundSize: 'contain',
            zIndex: 1
          }}
        />

      </Styled.Inner>
    </Styled.Container>
  );
};

export default React.memo(SAPHeroBanner);
